import { connect } from "react-redux";
import { PageList, PageListWeb } from "senac-components";
import { commonSlice, contentSlice, userDataSlice } from "../store/reducers";
import { RootState, AppDispatch } from "../store";
import {
  PageBookDetailPropsDispach,
  PageBookDetailState,
} from "senac-components/dist/pages/Mobile/PageBookDetail";
import { Wrapper, WrapperDispatchProps, WrapperStateProps } from "./Wrapper";
import {
  Content,
  ContentHeaderOptionItem,
  MenuOptions,
  ReadingListItem,
} from "senac-components/dist/pages/Mobile/PageInterfaces";
import {
  PageLisDispach,
  PageListState,
} from "senac-components/dist/pages/Mobile/PageList";
import {
  createTagPage,
  FavoritesInternalTag,
  insertInTagActiveContent,
  removeFromTagActiveContent,
} from "../store/reducers/userDataSlice";
import { showContentDetail } from "../store/reducers/contentSlice";
import { filterContent } from "../store/reducers/common";

const mapState = (state: RootState, props: any) => {
  
  const activeContent = state.contentState.allContents.find(p=> p.uid == state.contentState.activeContentUid);
  const content = { ...(activeContent ?? { uid: "-" }) };
  var data = state.userDataState.userData.filter(p=> p.tags && p.tags.length > 0 && p.targetType == "ManagedContent" && p.contextType == "ManagedContent" && p.contextUid == content.uid);
  var uniqueTags = data.map(p=>  p.tags ?? []).reduce((p, c)=>  [...new Map([...c, ...p].map(p=> [p.uid, p])).values()], []);
  var isFavorited = uniqueTags.find(p=> p.name == FavoritesInternalTag) != undefined;

  const selectedList = uniqueTags.map(p=> p.uid);
  const available = state.userDataState.tags?.filter((t) => t.name != FavoritesInternalTag);

  let result: PageListState = {
    contentsFavorited: isFavorited ? [content.uid] : [],
    contentsDownloaded: [],
    selected: selectedList,
    itemsLists: available,
    content: content
  };
  return result;
};

const mapDispatch = (dispatch: AppDispatch, props: any) => {
  const result: PageLisDispach = {
    onSelectItemChange: (item: ReadingListItem, status: boolean) => {
      if (status) {
        dispatch(insertInTagActiveContent(item.uid));
      } else {
        dispatch(removeFromTagActiveContent(item.uid));
      }
    },
    onSelectedHeaderBack: () => dispatch(commonSlice.actions.backPage()),
    onSelectedHeaderMenuOption: (option: ContentHeaderOptionItem) =>
      dispatch(contentSlice.actions.goToContentInfo(option)),
    onSelectedNavigationPageOption: (option: MenuOptions) =>
      dispatch(commonSlice.actions.goToPage(option)),
    onCreateList: () => dispatch(createTagPage()),
    onChangeFilter: (filter) => {
      if (filter.query == undefined) return;
      dispatch(filterContent({ query: filter.query }));
    },
  };
  return result;
};

const WPageBookReadingList = () => {
  const Mobile = connect(mapState, mapDispatch)(PageList);
  const Web = connect(mapState, mapDispatch)(PageListWeb);
  if(window.innerWidth < 1024) return <Mobile />
  return <Web />
}

export { WPageBookReadingList };
